module.exports = __webpack_public_path__ + "img/5.7dcc902f.svg";